import Image from 'next/image'
import useI18n from 'src/hooks/use_i18n'
import { PlatformItem } from 'src/types'
import DefaultIcon from '../DefaultIcon'
import styles from './index.module.scss'

export default function Card({ cover_image, classify_name, alt_label, platform, url, about }: PlatformItem) {
  const { activeLocale: locale } = useI18n()
  const handleClick = () => {
    window.ga?.sendEvent?.('事件操作', 'platform-点击跳转详情页', platform)
  }
  const defaultAlt = `logo of ${platform}`
  return (
    <a
      href={`/${locale}/brands/${url}`}
      target="_blank"
      className="col-12 col-sm-4 col-md-3"
      title={platform}
      onClick={handleClick}
    >
      <figure>
        <div className={styles.cardMain}>
          <div className={styles.info}>
            <div className={styles.cardImg}>
              {cover_image ? (
                <Image
                  loading="lazy"
                  width={48}
                  height={48}
                  className="lazy-image-fill"
                  src={cover_image}
                  alt={alt_label || defaultAlt}
                />
              ) : (
                <DefaultIcon name={platform} size={48} title={defaultAlt} />
              )}
            </div>
            <div className={styles.name}>
              <span title={platform}>{platform}</span>
              <span>{classify_name}</span>
            </div>
          </div>
          <div className={styles.desc}>
            <p>{about}</p>
          </div>
        </div>
      </figure>
    </a>
  )
}
